jQuery(($) => {
	if (window.location.hash && window.location.hash === "#sweepstakes") {
		$("#sweepstakes").removeClass("hidden");

		/* 		$("#footer").append(
        '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=125603944727793&ev=PageView" /><img style="width:1px; height:1px;" src="https://servedby.flashtalking.com/spot/1/15214;141510;12636/?spotName=2024_SWA_Sweepstakes_SunsetontheBeach_Pageview&cachebuster=[' +
            Math.floor(Math.random() * 31231432431212) +
            ']" />'
    ); */
	}
	if (window.location.hash && window.location.hash === "#thankyou") {
		$("#sweepstakes").addClass("hidden");
		$("#thankyou").removeClass("hidden");
	}
	if (window.location.hash && window.location.hash === "#entered") {
		$("#sweepstakes").addClass("hidden");
		$("#entered").removeClass("hidden");
	}
});

function cheersSuccess(form, response, whatForm = 1) {
	console.log("Success!", response);
	form.style.display = "none";

	if (whatForm == 1) {
		document.getElementById("sweepstakes").classList.add("hidden");
		document.getElementById("thankyou").classList.remove("hidden");
	} else if (whatForm == 2) {
		document.getElementById("sweepstakes").classList.add("hidden");

		document.getElementById("thankyou").classList.remove("hidden");
	}

	//window.location.hash = "thankyou";
	const random = Math.floor(Math.random() * 10000000000000000000);

	window.scrollTo(0, 0);

	$("#footer").append(`
		<div style="position:absolute;"><img style="width:1px; height:1px;" src="https://servedby.flashtalking.com/spot/1/15214;143906;12636/?spotName=2024_SWA_SEC_Sweeps_Submit&cachebuster=${random}"/></div>
	`);
}

function cheersError(form, error) {
	console.error("Error!", error.message);
	document.getElementById("cheers-error").classList.remove("hidden");
}

if ($("#sweepstake-form").length > 0) {
	document.addEventListener("DOMContentLoaded", () => {
		const formName = $("#sweepstake-form").attr("name");
		const form = document.forms[formName];

		let isSubmitting = false;

		form.addEventListener("submit", async (e) => {
			e.preventDefault();

			if (isSubmitting) return;
			isSubmitting = true;

			// Does #sweepstakes have class basketball
			const isBasketball = document
				.getElementById("sweepstakes")
				.classList.contains("basketball");

			let whatForm = 1;
			if (isBasketball) {
				whatForm = 2;
			}

			const formData = getFormData(whatForm);
			//const email = formData[9]; // email is field 9
			//const mailchimpData = getMailchimpData(formData);

			try {
				const mbrCardNumber = document.querySelector(
					"#form_field_rewards"
				).value;

				const isValid = transformMbrCardNumber(mbrCardNumber);
				if (isValid) {
					const hasDuplicate = await checkForDuplicates(
						formData,
						whatForm
					);

					if (hasDuplicate) {
						isSubmitting = false;

						if (isBasketball) {
							document
								.getElementById("sweepstakes")
								.classList.add("hidden");

							document
								.getElementById("entered")
								.classList.remove("hidden");
						} else {
							document
								.getElementById("sweepstakes")
								.classList.add("hidden");
							document
								.getElementById("entered")
								.classList.remove("hidden");
						}

						return;
					}

					await submitForm(formData, form, whatForm);
					//console.log("Mailchimp Data:", mailchimpData);
					//await submitToMailchimp(email, mailchimpData); //mailchimpData
				} else {
					console.log("Invalid card number");
					document
						.getElementById("form_field_rewards")
						.classList.remove("valid");

					document
						.getElementById("form_field_rewards")
						.classList.add("invalid");

					return;
				}
			} catch (error) {
				console.error("An error occurred during submission:", error);
			} finally {
				isSubmitting = false;
			}
		});

		function getFormData(whatForm = 1) {
			const prom = document.querySelector(
				"#form_field_promotional_emails"
			).checked
				? 1
				: 0;
			const consent = document.querySelector("#consent").checked
				? "Yes"
				: "No";

			return {
				3: document.querySelector("#form_field_name").value,
				5: document.querySelector("#form_field_last").value,
				8: document.querySelector("#form_field_phone").value,
				9: document.querySelector("#form_field_email").value,
				10: document.querySelector("#form_field_rewards").value,
				6: document.querySelector("#form_field_zip").value,
				19: document.querySelector("#incoming_urls").value,
				18: document.querySelector("#referrer_source").value,
				15: document.querySelector("#utm_source").value,
				17: document.querySelector("#utm_medium").value,
				16: document.querySelector("#utm_campaign").value,
				14.1: prom,
				12.1: consent,
				form_id: whatForm,
			};
		}

		function getMailchimpData(formData) {
			return {
				FNAME: formData[3] || "", // First name
				LNAME: formData[5] || "", // Last name
				PHONE: formData[8] || "", // Phone number
				ZIP: formData[6] || "", // ZIP code
				COMMERCIAL: formData[12.1] === "Yes" ? "yes" : "no", // Convert "Yes" to 1 and "No" to 0
				RAPID: formData[10] || "", // Rewards field
			};
		}

		async function checkForDuplicates(formData, whatForm = 1) {
			try {
				const phoneDuplicates = await fetchEntriesByField(
					8,
					formData[8],
					whatForm
				);
				const emailDuplicates = await fetchEntriesByField(
					9,
					formData[9],
					whatForm
				);
				const rewardsDuplicates = await fetchEntriesByField(
					10,
					formData[10],
					whatForm
				);

				return (
					phoneDuplicates.length > 0 ||
					emailDuplicates.length > 0 ||
					rewardsDuplicates.length > 0
				);
			} catch (error) {
				console.error("Error during duplicate check:", error);
				return false;
			}
		}

		async function fetchEntriesByField(fieldKey, fieldValue, whatForm = 1) {
			const searchParams = new URLSearchParams({
				search: JSON.stringify({
					field_filters: [
						{ key: fieldKey.toString(), value: fieldValue },
					],
				}),
				page_size: 100,
				current_page: 1,
			});

			try {
				const response = await $.ajax({
					type: "GET",
					url: `https://southwestsecsweepstakes.com/wp-json/gf/v2/forms/${whatForm}/entries?${searchParams}`,
					beforeSend: (xhr) => {
						xhr.setRequestHeader(
							"Authorization",
							"Basic " +
								btoa(
									"ck_00070598a0487836e17116ef38dc5e05e340be02:cs_85d208349c7a9d0715c2cab22cb10823f5744036"
								)
						);
					},
					contentType: "application/json",
				});

				return response.entries || [];
			} catch (error) {
				throw new Error(`
					Fetch entries by field failed: ${error.responseText}
				`);
			}
		}

		function submitForm(formData, form, whatForm) {
			return $.ajax({
				type: "POST",
				url: `https://southwestsecsweepstakes.com/wp-json/gf/v2/forms/${whatForm}/entries`,
				beforeSend: (xhr) => {
					xhr.setRequestHeader(
						"Authorization",
						"Basic " +
							btoa(
								"ck_00070598a0487836e17116ef38dc5e05e340be02:cs_85d208349c7a9d0715c2cab22cb10823f5744036"
							)
					);
				},
				data: JSON.stringify(formData),
				contentType: "application/json",
				success: (response) => {
					console.log("Form submitted successfully!");
					cheersSuccess(form, response, whatForm);
				},
				error: (response) => {
					cheersError(form, response);
					console.error(
						"Form submission failed: ",
						response.responseText
					);
				},
			});
		}

		async function submitToMailchimp(email, mergeFields = {}) {
			const mailchimpData = {
				email_address: email,
				merge_fields: mergeFields,
				status: "subscribed", // Or "pending" for double opt-in
			};

			try {
				const response = await fetch(
					"https://mailchimptia.netlify.app/.netlify/functions/subscribe-to-mailchimp",
					{
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(mailchimpData),
					}
				);

				if (!response.ok) {
					const error = await response.json();
					throw new Error(
						error.error || "Failed to subscribe user to Mailchimp."
					);
				}

				const data = await response.json();
				console.log("User subscribed successfully:", data.message);
			} catch (error) {
				console.error("Mailchimp subscription error:", error);
			}
		}
	});
}

function isValidEmail(email) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(String(email).toLowerCase());
}

if (document.getElementById("form_field_rewards")) {
	var rewards = document.getElementById("form_field_rewards");

	rewards.addEventListener("input", function () {
		const mbrCardNumber = rewards.value;
		const isValid = transformMbrCardNumber(mbrCardNumber);

		if (isValid) {
			console.log("Valid card number");
			document
				.getElementById("form_field_rewards")
				.classList.remove("invalid");
			document
				.getElementById("form_field_rewards")
				.classList.add("valid");
		} else {
			console.log("Invalid card number");
			document
				.getElementById("form_field_rewards")
				.classList.remove("valid");

			document
				.getElementById("form_field_rewards")
				.classList.add("invalid");
		}
	});
}

function transformMbrCardNumber(mbrCardNumber) {
	if (mbrCardNumber.length < 14) {
		var mbrCardNumber = mbrCardNumber.padStart(14, "0");
	}

	const first13Digits = Number(mbrCardNumber.substring(0, 13));
	const modulusResult = first13Digits % 7;
	const fourteenthCharacter = mbrCardNumber.charAt(13);

	if (modulusResult == fourteenthCharacter) {
		return true;
	} else {
		return false;
	}
}

if (document.querySelector("button.button")) {
	document
		.querySelector("button.button")
		.addEventListener("click", function () {
			let consent = document.getElementById("consent").checked;
			let fields = true;
			if (
				document.getElementById("form_field_name").value == "" &&
				document.getElementById("form_field_last").value == "" &&
				document.getElementById("form_field_email").value == "" &&
				document.getElementById("form_field_phone").value == "" &&
				document.getElementById("form_field_zip").value == ""
			) {
				fields = false;
			}

			if (fields) {
				if (!consent) {
					document
						.getElementById("cheers-error-checks")
						.classList.remove("hidden");
				}
			}
		});
}
